import { g } from "../../util/index.ts";

// The challenge gameAttr is optional (unset on normal leagues) and g.get
// throws on unset keys — same convention as getRosterLock: always read it
// through this guard.
export const getChallenge = () =>
	Object.hasOwn(g, "challenge") ? g.get("challenge") : undefined;

export default getChallenge;
